<template>
  <div class="page-business-intelligence-competitor-performance">
    <BICompetitorSummary :dates="dates" @on-date-changed="updateDateRange" @on-edit-clicked="onEditClicked" />
    <BITenders :dates="dates" :competitorId="competitorId" @tender-clicked="onTenderClicked" />
    <TenderDetailsDialog ref="tenderDetailsDialog" :tender="selectedTender" :competitorId="competitorId" />
    <EditCompetitorDialog ref="editCompetitorDialog" @action-succeeded="onEdited" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import EditCompetitorDialog from '@/views/business-intelligence/EditCompetitorDialog.vue';
import BICompetitorSummary from '@/components/page-business-intelligence/BICompetitorSummary.vue';
import BITenders from '@/components/page-business-intelligence/BITenders.vue';
import TenderDetailsDialog from '@/components/page-business-intelligence/TenderDetailsDialog.vue';
import { getStartOfYear, getToday } from '@/util/date-util';

export default {
  name: 'PageBICompetitorPerformance',
  components: {
    BICompetitorSummary,
    BITenders,
    TenderDetailsDialog,
    EditCompetitorDialog,
  },
  computed: {
    ...mapGetters('biDashboard', { competitor: 'competitor', savedDates: 'dates' }),
  },
  data() {
    return {
      dates: [getStartOfYear(), getToday()], // Default to current year
      competitorId: this.$route.params.competitorId,
      selectedTender: null,
    };
  },
  methods: {
    ...mapActions('biDashboard', ['getCompetitor', 'setDates']),
    updateDateRange(dates) {
      this.setDates(dates);
      this.dates = dates;
    },
    onTenderClicked(tender) {
      this.selectedTender = tender;
      this.$refs.tenderDetailsDialog.openDialog();
    },
    onEditClicked() {
      this.$refs.editCompetitorDialog.open(this.competitor);
    },
    onEdited() {
      this.getCompetitor(this.competitorId);
    },
  },
  created() {
    this.getCompetitor(this.competitorId);
    if (this.savedDates && this.savedDates.length === 2) {
      this.dates = this.savedDates;
    }
  },
};
</script>

<style lang="scss">
.page-business-intelligence-competitor-performance {
  padding: 32px;

  // Phones: the screen's gutter, and a tender drawer no wider than the screen.
  @include screen-below('tablet') {
    padding: $phone-page-gutter;

    .__tender-drawer {
      min-width: 0;
    }
  }

  .__tender-drawer {
    min-width: 450px;
  }
}
</style>
